/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UserProfile,
} from '../models';
import {
    UserProfileFromJSON,
    UserProfileToJSON,
} from '../models';

export interface GetProfileRequest {
    xAccessTokenType: GetProfileXAccessTokenTypeEnum;
    xOggUserEmail: string;
}

/**
 * 
 */
export class ProfileApiApi extends runtime.BaseAPI {

    /**
     */
    async getProfileRaw(requestParameters: GetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserProfile>> {
        if (requestParameters.xAccessTokenType === null || requestParameters.xAccessTokenType === undefined) {
            throw new runtime.RequiredError('xAccessTokenType','Required parameter requestParameters.xAccessTokenType was null or undefined when calling getProfile.');
        }

        if (requestParameters.xOggUserEmail === null || requestParameters.xOggUserEmail === undefined) {
            throw new runtime.RequiredError('xOggUserEmail','Required parameter requestParameters.xOggUserEmail was null or undefined when calling getProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xAccessTokenType !== undefined && requestParameters.xAccessTokenType !== null) {
            headerParameters['x-access-token-type'] = String(requestParameters.xAccessTokenType);
        }

        if (requestParameters.xOggUserEmail !== undefined && requestParameters.xOggUserEmail !== null) {
            headerParameters['x-ogg-user-email'] = String(requestParameters.xOggUserEmail);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileFromJSON(jsonValue));
    }

    /**
     */
    async getProfile(requestParameters: GetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserProfile> {
        const response = await this.getProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetProfileXAccessTokenTypeEnum = {
    Ado: 'ado',
    Outseta: 'outseta',
    Jira: 'jira',
    Test: 'test'
} as const;
export type GetProfileXAccessTokenTypeEnum = typeof GetProfileXAccessTokenTypeEnum[keyof typeof GetProfileXAccessTokenTypeEnum];
